import React ,{ useEffect, useState } from 'react'
import api from '../config/api'
import { Route, Redirect } from 'react-router-dom'
import { useDispatch ,useSelector} from 'react-redux'
import { actions } from '../store/reducers/userReducer'
import Loading from "./loading";

export default function PrivateRoute({ history,...props}) {

    const state = useSelector(state => state.userReducer);

    const [validade,setValidade] = useState(false);
    const [loading,setLoading] = useState(true);

    const dispatch = useDispatch();

    useEffect(()=>{
      if (!state.logged) {
        const token = localStorage.getItem('token')
        
        if(token) {
          api.post('/authenticate', '', {
            headers: {
              token: token
            }
          })
          .then((response) => {
            response.data.logged = true
            dispatch(actions.setIfosUser(response.data))
          })
            .catch((error) => {
              if (error.response) {
                if (error.response.data.message === "token invalid") {
                } else if (error.response.data.message === "token not declared") {
                } else if (error.response.data.message === "error in athentication") {
                }
            }
          })
        }
        setValidade(false);
        setLoading(false);
      } 
      setValidade(false);
      setLoading(false);
    },[]) // eslint-disable-line
    if(!loading){
        return validade ? <Route {...props}/> : <Redirect to="/login" />
    } else {
        return <Loading/>
    }
    
}